import { useScrollReset } from '../hooks';

export const ScrollReset = () => {
  useScrollReset();

  return null;
};
